import styled from "styled-components";
import { ReactComponent as LeftArrow } from "../../assets/icons/chevron-left.svg";
import { ReactComponent as RightArrow } from "../../assets/icons/chevron-right.svg";

export const MediaSliderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  /* max-width: 1280px; */
  overflow: hidden;
  width: 100%;
  height: fit-content;
  border-radius: 20px;
  max-height: 370px;

  &::before {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    content: "";
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.4) 0%,
      rgba(0, 0, 0, 0) 50%
    );
  }
  @media (max-width: 1500px) {
    /* max-height: 200px; */
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  position: absolute;
  z-index: 15;
  left: 0;
  top: 0;
  border-radius: 20px;
  padding: 24px;
  justify-content: space-between;
  width: 350px;
  height: 100%;
  @media (max-width: 800px) {
    max-width: 200px;
  }
`;
export const SmallText = styled.span`
  color: #fff;
  font-family: "Avenir-Medium";
  font-size: 12px;
  font-weight: 600;
  line-height: 16px; /* 133.333% */
`;
export const BigText = styled.span`
  color: #fff;
  font-family: "Avenir-Heavy";
  font-size: 36px;
  font-weight: 700;
  line-height: 35px; /* 133.333% */
  @media (max-width: 800px) {
    font-size: 2.4rem;
    line-height: 3rem;
  }
`;

export const Button = styled.button`
  display: flex;
  height: 44px;
  /* padding: 12px 24px; */
  justify-content: center;
  align-items: center;
  cursor: pointer;
  outline: none;
  border-radius: 9999px;
  border: none;
  max-width: 175px;
  background: #484888;

  color: #fff;
  font-family: "Avenir-Heavy";
  font-size: 14px;
  font-weight: 700;
  line-height: 20px; /* 142.857% */
  transition: all 0.3s ease-in-out;
  &:hover {
    scale: 1.025;
  }
  &:active {
    scale: 1;
  }
`;

export const GiftBoxImageContainer = styled.div`
  /* padding: 0px 40px; */
  border-radius: 20px;
  position: relative;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  /* cursor: grab;

  &:active {
    cursor: grabbing;
  } */

  @media (max-width: 870px) {
    padding: 0rem;
  }
`;

export const Image = styled.img`
  /* border-radius: 20px; */
  /* width: 1280px; */
  width: 100%;

  /* max-width: 540px; */

  user-select: none;
  transition: all 0.3s ease-in-out;
  pointer-events: none;
  object-fit: cover;
  @media (max-width: 1700px) {
    width: 100%;
    height: auto;
  }
  @media (max-width: 550px) {
    height: 200px;
  }
`;

export const LeftIcon = styled(LeftArrow)`
  /* fill: #fff; */
  fill: #484888;
  text-shadow: 0px 5px 10px black;
`;
export const RightIcon = styled(RightArrow)`
  /* fill: #fff; */
  fill: #484888;
  text-shadow: 0px 5px 10px black;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: rgba(255, 255, 255, 0.45);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  width: 3.2rem;
  height: 3.2rem;
  outline: 1px solid #48488815;
  border-radius: ${(props) =>
    props.$right ? "0px 20px 20px 0px" : "20px 0px 0px 20px"};
  transition: all 0.3s ease-in-out;
  opacity: 0.5;
  z-index: 10;
  &:hover {
    background-color: rgba(255, 255, 255, 0.65);
    opacity: 1;
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  border-radius: 20px;
  position: absolute;
  z-index: 501;
  align-items: center;
  top: 3rem;
  right: 3rem;
  box-shadow:
    0px 5px 10px rgba(0, 0, 0, 0.15),
    0px 2.5px 5px rgba(0, 0, 0, 0.2);
`;

export const Line = styled.span`
  box-shadow:
    0px 5px 10px rgba(0, 0, 0, 0.15),
    0px 2.5px 5px rgba(0, 0, 0, 0.2);
  width: 4.8rem;
  height: ${(props) => (props.$active ? "0.3rem" : "0.1rem")};
  background: ${(props) =>
    props.$active ? "#fff" : "rgba(255, 255, 255, 0.5)"};

  position: relative;
`;

export const LinesContainer = styled.div`
  display: flex;
  justify-content: center;
  cursor: pointer;
  top: 20px;
  position: absolute;
  align-items: center;
  height: 0.3rem;
  gap: 0.5rem;
  z-index: 500;
`;

export const FillLine = styled.div`
  height: 0.3rem;
  background: #fff;
  /* background: #484888; */
  position: absolute;
  top: -0.1rem;
  z-index: 20;
  left: 0;
  box-shadow:
    0px 5px 10px rgba(0, 0, 0, 0.15),
    0px 2.5px 5px rgba(0, 0, 0, 0.2);
`;
